import providers from 'common/config/providers.json';

export class AuthOptions {
  options = {
    "all": "Телефон або пошта",
    "email": "Пошта",
    "phone": "Телефон"
  }

  constructor(params) {
    const safeParams = params||{};
    const options = safeParams.login_opts||'';

    this.contents = options.split(',')||[];

    this.isBlank =
      params == null ||
        params.login_opts == null || Object.keys(params).length === 0;
  }


  title() {
    const { contents, options } = this;
    const hasPhone = contents.includes('phone');
    const hasEmail = contents.includes('email');

    if (this.isBlank || (hasPhone && hasEmail))
      return options['all'];
    else if (hasPhone)
      return options['phone'];
    else if (hasEmail)
      return options['email'];
  }

  inputs() {
    const inputs = ['email', 'phone'];

    if (this.isBlank)
      return inputs;

    const { contents } = this;
    const result = [];

    for (let i of inputs) {
      if (contents.includes(i))
        result.push(i);
    }

    return result;
  }

  providers() {
    if (this.isBlank)
      return null;

    const social =
      this.contents.filter(i => !['email', 'phone'].includes(i));
      
    return providers.filter(provider => social.indexOf(provider.url) !== -1)
  }

};
